enum CfiStandard {
    'CFI2001' = "ISO 10962:2001",
    'CFI2015' = "ISO 10962:2019",
}

export default CfiStandard;
